export default __webpack_public_path__ + "static/media/Wall_Conveyor_x2_Grey.256.f51c6dc2.png";